const en = {
  home: {
    navHome: 'Home',
    navTools: 'Tools',
    navDocs: 'Learn',
    navAirdrop: 'Airdrop',
    navRebate: 'Rebate',
    login: 'Login',
    register: 'Register',
    heroTitle: 'GHOST',
    heroSubtitle: 'Web3 Community · Airdrops · Trading Tutorials',
    heroDesc: 'Join us for the latest airdrop info, systematic trading tutorials, and professional charting tools',
    joinNow: 'Join Now',
    learnMore: 'Learn More',
    sectionTools: 'Trading Tools',
    airdropTeaserTitle: 'Community Airdrops',
    airdropTeaserDesc: 'Curated airdrop projects with exclusive community rewards — never miss an opportunity',
    marqueeRow1: 'Blockchain   Decentralized   Smart Contract   Airdrop   DeFi   NFT   Web3   Wallet   Private Key   Public Chain   Gas Fee   Liquidity   Staking   Hashrate   DAO   Zero Knowledge Proof   Cross-chain Bridge   Node   Consensus   Layer2   Tokenomics   On-chain Governance   Lightning Network   Oracle   Fragmentation   Mint   Merkle Tree   Asymmetric Encryption   Distributed Ledger',
    marqueeRow2: 'Distributed Ledger   Asymmetric Encryption   Merkle Tree   Mint   Fragmentation   Oracle   Lightning Network   On-chain Governance   Tokenomics   Layer2   Consensus   Node   Cross-chain Bridge   Zero Knowledge Proof   DAO   Hashrate   Staking   Liquidity   Gas Fee   Public Chain   Private Key   Wallet   Web3   NFT   DeFi   Airdrop   Smart Contract   Decentralized   Blockchain',
    bannerTitle: 'Data-Driven',
    bannerHighlight: 'Trading Decisions',
    bannerDesc: 'Every signal is backed by deep analysis and multi-dimensional verification of massive data',
    startLearning: 'Start Learning',
    ctaTitle: 'Ready to get started?',
    ctaDesc: 'Register to participate in airdrops and access the latest learning resources',
    freeRegister: 'Free Register',
    proTitle: 'Unlock Pro',
    proDesc: 'Premium service — US stock/crypto market access, in-depth briefings + asset screening, full tool access + community',
    proCta: 'Learn More',
    proHint: 'US stock/crypto access · In-depth briefings + screening · Full tools + community',
    modeGrowth: 'Growth',
    modePro: 'Pro',
    growthHeroSubtitle: 'Books · Cognition · Learning Paths',
    growthHeroDesc: 'Free access to curated investment books, wealth cognition articles and systematic learning resources',
    growthDocsTitle: 'Recommended Books',
    growthDocsDesc: 'Classic investment reads, from beginner to advanced, build your knowledge system',
    celebrityTitle: 'Investor Wisdom',
    celebrityDesc: 'Timeless insights from the greatest investors to shape your financial mindset',
    growthArticlesTitle: 'Wealth Cognition',
    growthArticlesDesc: 'Understand the nature of wealth and build the right investment mindset',
    growthPathTitle: 'Learning Path',
    growthPathDesc: 'Start from zero, systematically master crypto investing',
    growthLessonsTitle: 'Trading From 0 to 1',
    growthLessonsDesc: 'Start with trading basics, platform workflows, and curated materials before tools and markets.',
    growthLessonExchangeTitle: 'Exchange Guides',
    growthLessonExchangeDesc: 'Download, register, bind rebate codes, and complete common platform setup.',
    growthLessonBooksTitle: 'Recommended Books',
    growthLessonBooksDesc: 'Use three classics to build technical analysis, systems, and trading psychology.',
    growthLessonPathTitle: 'Beginner Lessons',
    growthLessonPathDesc: 'Fill the foundation step by step, from key concepts to practical learning paths.',
    proHeroSubtitle: 'Tools · Data · In-depth Briefings',
    proHeroDesc: 'Professional trading tools, real-time market data and in-depth analysis briefings for your trading decisions',
    proToolsTitle: 'Trading Tools',
    proAirdropTitle: 'Airdrop Campaigns',
    proAirdropDesc: 'Curated community airdrop tasks with rewards, timelines, and participation links',
    loginToUse: 'Login to Use',
    btcLive: 'BTC Live Price',
    btcLoading: 'Loading...',
    wechatTip: 'WeChat: admiraltyz',
    officialAccountTip: 'Follow Us',
    copyright: '© 2026 GHOST. All rights reserved.',
    proCommunityNote: 'Join our community via WeChat Official Account below',
    footerAbout: 'About',
    footerContact: 'Contact',
    footerTerms: 'Terms of Service',
    footerGrowth: 'Growth',
    footerArticles: 'Articles',
    footerBooklist: 'Book List',
    footerInvite: 'Invite & Register',
    footerPro: 'Pro',
    footerKlineTool: 'K-line Tools',
    footerDataAnalysis: 'Data Analysis',
    footerFinCalendar: 'Financial Calendar',
    footerFollow: 'Follow Us',
    footerWechat: 'WeChat Official',
    footerTwitter: 'Twitter / X',
    footerTelegram: 'Telegram',
    footerSlogan: 'Web3 Community · Airdrops · Trading Tutorials',
    sentimentTitle: 'Market Sentiment',
    sentimentDesc: 'Real-time crypto market sentiment and key indicators',
    sentimentFng: 'Fear & Greed Index',
    sentimentFngExtremeFear: 'Extreme Fear',
    sentimentFngFear: 'Fear',
    sentimentFngNeutral: 'Neutral',
    sentimentFngGreed: 'Greed',
    sentimentFngExtremeGreed: 'Extreme Greed',
    sentimentBtcDominance: 'BTC Dominance',
    sentimentTotalMcap: 'Total Crypto MCap',
    sentimentUpdated: 'Updated',
    sentimentLoading: 'Loading...',
    sentimentError: 'Failed to fetch data',
    heatmapTitle: 'Sector Heatmap',
    heatmapDesc: 'Focused market preview. Open the toolbox for the full heatmap.',
    heatmapCryptoTitle: 'Crypto Market',
    heatmapCryptoDesc: 'Core crypto 24h performance',
    heatmapStocksTitle: 'US Stocks Watch',
    heatmapStocksDesc: 'Key tech and crypto-linked equities',
    heatmapFeatured: 'Watch',
    heatmapViewFull: 'View Full Version',
    heatmapSectorLayer1: 'Layer 1',
    heatmapSectorDefi: 'DeFi',
    heatmapSectorMeme: 'Meme',
    heatmapSectorL2: 'Layer 2',
    heatmapSectorGaming: 'Gaming / Metaverse',
    heatmapSectorAi: 'AI',
    heatmapSectorOther: 'Other',
    heatmapLoading: 'Loading...',
    heatmapError: 'Failed to fetch data',

    holdings13fTitle: 'Institutional Holdings 13F',
    holdings13fDesc: 'Track top institutional holdings from latest quarterly filings',
    holdings13fWhy: 'Why follow institutional holdings?',
    holdings13fWhyDesc: 'Top hedge funds and asset managers are required to disclose their holdings to the SEC every quarter (13F filings) — the most authoritative public data on "smart money" flows. Tracking position changes helps you spot emerging trends, validate investment theses, and adjust your strategy when institutions build or cut positions.',
    holdings13fLoading: 'Loading...',
    holdings13fError: 'Failed to fetch data',
    holdings13fStock: 'Stock Name',
    holdings13fShares: 'Shares',
    holdings13fValue: 'Value ($K)',
    holdings13fWeight: 'Weight',
    holdings13fDate: 'Filing Date',
    holdings13fTotal: 'Total Portfolio Value',
    holdings13fTop10: 'Top 10 Holdings',
    holdings13fNoData: 'No data available',
    holdings13fSource: 'Source: SEC EDGAR',
    holdings13fViewDetail: 'View Full Holdings →',

    proNavOverview: 'Overview',
    proNavTools: 'Tools',
    proNavHeatmap: 'Heatmap',
    proNavHoldings: 'Institutions',
    proNavFundamentals: 'Fundamentals',
    proNavAirdrop: 'Airdrop',
    proNavCommunity: 'Community',

    cryptoDetailBack: '← Back',
    cryptoDetailMarketCap: 'Market Cap',
    cryptoDetailCirculating: 'Circulating Supply',
    cryptoDetailFng: 'Fear & Greed',
    cryptoDetailDominance: 'Dominance',
    cryptoDetailPriceTrend: 'Price Trend',
    cryptoDetailOnchain: 'On-chain Metrics',
    cryptoDetailExchangeInflow: 'Exchange Net Inflow',
    cryptoDetailMinerSell: 'Miner Sell Pressure',
    cryptoDetailNvt: 'NVT Ratio',
    cryptoDetailMvrv: 'MVRV',
    cryptoDetailWhaleSignal: 'Whale Watch',
    cryptoDetailWhaleHighRisk: 'High Risk Signal',
    cryptoDetailWhaleDetected: 'Volume-price divergence · Whale transfers detected',
    cryptoDetailWhaleViewDetail: 'View Details →',
    cryptoDetailWhaleNormal: 'No significant anomalies detected',
    cryptoDetailTools: 'Related Tools',
    cryptoDetailChartPlaceholder: 'Price chart (TradingView embed in production)',
    cryptoDetailTime1d: '1D',
    cryptoDetailTime1w: '1W',
    cryptoDetailTime1m: '1M',
    cryptoDetailLoading: 'Loading...',
    cryptoDetailNotFound: 'Coin data not found',

    instDetailBack: '← Back',
    instDetailManager: 'managed by',
    instDetailQuarterly: '13F Quarterly',
    instDetailLatestUpdate: 'Latest Update',
    instDetailTotalValue: 'Total Portfolio Value',
    instDetailTabOverview: 'Holdings Overview',
    instDetailTabHistory: 'Historical Changes',
    instDetailTabConcentration: 'Concentration',
    instDetailStock: 'Stock',
    instDetailValue: 'Market Value',
    instDetailWeight: 'Weight',
    instDetailShares: 'Shares',
    instDetailConcentration: 'Holdings Concentration (Top 5)',
    instDetailAbout13f: 'About 13F',
    instDetailAbout13fDesc: 'Institutional investors managing over $100M must file quarterly 13F reports with the SEC disclosing holdings. ~45 day delay.',
    instDetailRelatedStocks: 'Related Stocks',
    instDetailDetail: 'Details →',
    instDetailLoading: 'Loading...',
    instDetailNotFound: 'Institution data not found',
    instDetailSource: 'Source: SEC 13F Quarterly',
    instDetailSourceNote: 'Updated quarterly (~45 day delay)',

    stockFundTitle: 'Stock Fundamentals',
    stockFundSubtitle: 'Live Monitoring · Fundamentals Summary · Earnings Calendar',
    stockFundCompany: 'Company',
    stockFundTicker: 'Ticker',
    stockFundRevenue: 'Latest Q Revenue',
    stockFundNetIncome: 'Net Income',
    stockFundNextEarnings: 'Next Earnings',
    stockFundRating: 'Rating',
    stockFundAction: 'Action',
    stockFundViewDetail: 'Detail →',
    stockFundRatingBuy: 'Buy',
    stockFundRatingHold: 'Hold',
    stockFundRatingWatch: 'Watch',
    stockFundLoading: 'Loading fundamentals...',
    stockFundError: 'Failed to load data',
    stockFundSource: 'Source: SEC EDGAR / Yahoo Finance',
  },

  nav: {
    profile: 'Profile',
    logout: 'Logout',
  },

  login: {
    title: 'Ghost Community',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    submit: 'Login',
    submitting: 'Logging in...',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    fillAll: 'Please fill in all fields',
    invalidEmail: 'Invalid email format',
    userNotFound: 'User not found',
    accountError: 'Account data error, please contact admin',
    wrongPassword: 'Wrong password',
    loginFailed: 'Login failed',
    retryLater: 'Please try again later',
    validEmail: 'Please enter a valid email address',
  },

  register: {
    title: 'Create Account',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    inviteCodePlaceholder: 'Invite Code (optional)',
    submit: 'Register',
    submitting: 'Registering...',
    backToLogin: 'Back to Login',
    fillAll: 'Please fill in all fields',
    invalidEmail: 'Invalid email format',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordMismatch: 'Passwords do not match',
    emailExists: 'This email is already registered',
    success: 'Registration Successful',
    successMsg: 'Please login with your email and password',
    goToLogin: 'Go to Login',
    failed: 'Registration Failed',
    validEmail: 'Please enter a valid email address',
    retryLater: 'Please try again later',
    confirm: 'OK',
  },

  forgot: {
    title: 'Reset Password',
    emailPlaceholder: 'Email',
    nextStep: 'Next',
    newPasswordPlaceholder: 'New Password (min. 8 characters)',
    confirmPasswordPlaceholder: 'Confirm New Password',
    submit: 'Reset Password',
    submitting: 'Submitting...',
    backToLogin: 'Back to Login',
    enterEmail: 'Please enter your email',
    validEmail: 'Please enter a valid email address',
    emailNotRegistered: 'This email is not registered',
    queryFailed: 'Query Failed',
    passwordRequirement: 'Password Requirement',
    passwordTooShort: 'New password must be at least 8 characters',
    passwordMismatch: 'Password Mismatch',
    passwordMismatchMsg: 'The two passwords do not match',
    success: 'Reset Successful',
    successMsg: 'Password updated, please login with your new password',
    goToLogin: 'Go to Login',
    failed: 'Reset Failed',
    retryLater: 'Please try again later',
    confirm: 'OK',
  },

  airdrop: {
    title: 'Airdrop Campaigns',
    desc: 'Curated community airdrop tasks with rewards, timelines, and participation links.',
    descLabel: 'Description',
    startTime: 'Start Time: ',
    endTime: 'End Time: ',
    tbd: 'TBD',
    statusUpcoming: 'Upcoming',
    statusOngoing: 'Ongoing',
    statusEnded: 'Ended',
    filterAll: 'All',
    filterOngoing: 'Ongoing',
    filterUpcoming: 'Upcoming',
    filterEnded: 'Ended',
    loading: 'Loading...',
    noData: 'No activities',
    rewardLabel: 'Reward: ',
    deadlineLabel: 'Deadline: ',
    viewDetail: 'View Details',
    backHome: '← Back to Home',
    eyebrow: 'Airdrop',
    overview: 'Airdrop Overview',
  },

  profile: {
    saveSuccess: 'Saved Successfully',
    saveFailed: 'Save Failed',
    retryLater: 'Please try again later',
    confirm: 'OK',
    refreshed: 'Refreshed',
    refreshFailed: 'Refresh Failed',
    confirmLogout: 'Confirm Logout?',
    logout: 'Logout',
    cancel: 'Cancel',
    copied: 'Copied',
    points: 'Points',
    verified: 'Verified',
    unverified: 'Unverified',
    memberDays: 'Member {days} days',
    inviteCode: 'Invite Code:',
    copy: 'Copy',
    refreshing: 'Refreshing...',
    refreshInfo: 'Refresh Info',
    personalInfo: 'Personal Info',
    guideTab: 'Setup Guide',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Enter nickname',
    email: 'Email',
    binanceUID: 'Binance UID',
    binanceUIDPlaceholder: 'Enter Binance UID',
    binanceUIDHint: 'Bind your Binance account',
    bitgetUID: 'Bitget UID',
    bitgetUIDPlaceholder: 'Enter Bitget UID',
    bitgetUIDHint: 'Bind your Bitget account',
    wechat: 'WeChat',
    wechatPlaceholder: 'Enter WeChat ID',
    wechatHint: 'For customer service and event notifications',
    okxUID: 'OKX UID',
    okxUIDPlaceholder: 'Enter OKX UID',
    okxUIDHint: 'Bind your OKX account',
    parentInviteCode: 'Referral Code',
    none: 'None',
    parentCodeHint: 'Invite code used during registration',
    saving: 'Saving...',
    save: 'Save Changes',
    logoutBtn: 'Logout',
    guideTitle: 'Post-Registration Setup Guide',
    guide1Title: '1. Basic Info',
    guide1Nickname: 'Nickname: Chinese, English and numbers, 2-12 characters, changeable later.',
    guide1Email: 'Email: Cannot be changed after binding, used for login, password recovery, and notifications.',
    guide2Title: '2. Exchange Account Binding',
    guide2Binance: 'Binance UID: Login Binance → Profile to get (numeric ID)',
    guide2Bitget: 'Bitget UID: Login Bitget → Profile to get',
    guide2Okx: 'OKX UID: Login OKX → Profile to get',
    guide3Title: '3. Invite Code Info',
    guide3Parent: 'Referral Code: The invite code used during registration, for tracking referrals.',
    guide3Mine: 'My Invite Code: Auto-generated, share with friends to earn rewards.',
    guide4Title: '4. Important Notes',
    guide4Note1: 'Please ensure the bound exchange UID is your real info. False info may restrict your account.',
    guide4Note2: 'Submissions are reviewed within 1-3 business days, results sent via email.',
    guide4Note3: 'For questions, add customer service WeChat: admiraltyz',
    userNotFound: 'User record not found',
    inviteCodeLabel: 'Invite Code:',
    advancedUser: 'Advanced User',
    premium: 'premium',
  },

  tools: {
    proBannerTitle: 'Unlock More Pro Tools',
    proBannerDesc: 'Upgrade to Pro for exclusive strategies, advanced backtesting, and dedicated guidance.',
    proBannerCta: 'Contact Us to Upgrade',
    patternTitle: 'Pattern Match',
    patternSubtitle: 'Pattern Match',
    patternDesc: 'Capture recent BTC candlestick patterns and auto-match similar historical segments to visualize real follow-up performance.',
    detectiveTitle: 'Dump Detective 3.0',
    detectiveSubtitle: 'Dump Detective',
    detectiveDesc: 'Enter a BSC token contract address to generate a security, liquidity, and dump risk detection report.',
    levelsTitle: 'Support / Resistance',
    levelsSubtitle: 'Support / Resistance',
    levelsDesc: 'Query key support and resistance levels for major cryptocurrencies across multiple timeframes.',
    statusOnline: 'Live',
    btcHigh: '24h High',
    btcLow: '24h Low',
    btcCap: 'Market Cap',
    btcVol: '24h Volume',
  },

  docs: {
    bannerTitle: 'Trading Learning',
    bannerDesc: 'Exchange guides · Contract basics · Book recommendations',
    backToHome: '← Home',
    backToList: 'Back to Docs',
    all: 'All',
    prevDoc: '← Previous',
    nextDoc: 'Next →',
    pagination: 'Docs pagination',
    prevPage: 'Previous',
    nextPage: 'Next',
  },

  toolbox: {
    moreTools: 'More Tools',
    continueExplore: 'Explore the Toolbox',
    defaultDesc: 'All on-chain analysis, backtesting, and risk detection tools in one place.',
    openToolbox: 'Open Toolbox',
    backToTools: '← Back to Toolbox',
  },

  rebate: {
    bannerTitle: 'Register with invite code, earn 20% permanent fee rebate',
    bannerDesc: 'Free tools, choose the right account too. Invite code: ',
    bannerCta: 'Free Registration →',
    kicker: 'Permanent · Invite code {code} · Valid 2026',
    heroTitle: 'You pay fees every day but get zero rebate',
    heroDesc: 'Register on Binance, OKX, Bitget with {code} and get a fixed percentage of every fee returned. Already registered? You can try rebinding under platform rules.',
    pickExchange: 'Choose Exchange',
    viewRebind: 'View Rebinding Methods',
    inviteCode: 'Invite Code',
    inviteCodeLabel: 'Invite Code',
    universalCode: 'Universal Code',
    codeHint: 'Enter in the invite code field when registering, rebate activates automatically',
    overview: 'Rebate Overview',
    statExchanges: 'Exchanges Covered',
    statRebate: 'Standard Rebate',
    statCode: 'Universal Code',
    exchSubtitle: 'Pick an exchange, check rebate details',
    exchTitle: 'Exchange Rebate Hub',
    exchDesc: 'Curated platforms with registration steps, rebinding guides, and rebate entry points for your trading needs.',
    viewTutorial: 'View {name} Guide',
    feeSubtitle: 'Fee rates at a glance',
    feeTitle: 'Exchange Fee Comparison',
    feeDesc: 'Fees vary by VIP level and platform policy. Actual rates shown at order time.',
    compareItem: 'Comparison',
    binance: 'Binance',
    okx: 'OKX',
    bitget: 'Bitget',
    spotMaker: 'Spot Maker',
    lowestFee: 'Lowest Fee',
    rebindSubtitle: 'Registered but no invite code?',
    rebindTitle: 'Already registered? Try rebinding',
    rebindDesc: 'Rebinding rules vary by platform. Check your account status first, then follow the guide.',
    rebindBinanceTitle: 'Binance Rebind',
    rebindBinanceSubtitle: '3 methods',
    rebindB1: 'Official rebinding link',
    rebindB2: 'Delete and re-register',
    rebindB3: '90-day inactive recall',
    rebindOkxTitle: 'OKX Rebind',
    rebindOkxSubtitle: '4 methods',
    rebindO1: 'No upline application',
    rebindO2: '180-day idle rebind',
    rebindO3: 'High-volume user channel',
    rebindBitgetTitle: 'Bitget Binding',
    rebindBitgetSubtitle: 'New account preferred',
    rebindBg1: 'Enter invite code during registration',
    rebindBg2: 'Check account rebate relationship',
    rebindBg3: 'Bind UID for verification',
    ctaTitle: 'Still hesitating? Every day without a code is lost rebate',
    ctaDesc: 'Rebate is long-term cash flow, not a one-time discount. Pick your platform and enter {code} when registering or rebinding.',
    ctaBtn: 'View Binance Guide Now',
    breadcrumb: 'Breadcrumb',
    home: 'Home',
    rebate: 'Rebate',
    detailHeroTitle: 'Don\'t let fees slip away',
    viewSteps: 'View Registration Steps',
    registerWithCode: 'Register with {code}, start earning rebate',
    viewRebindGuide: 'View Rebinding Guide',
    whyChoose: 'Why Choose It',
    rebindGuideTitle: 'Rebinding Guide',
    newUserRegister: 'New User Registration',
    stepsTitle: 'Registration Steps',
    openRegister: 'Open {name} Registration',
    extraBenefits: 'Extra Benefits',
    checkAfterRegister: 'Check After Registration',
    rebateLabel: 'rebate',
    directRegister: 'Register Now',
    faqTitle: 'FAQ',
    otherPlatforms: 'Other Platforms',
  },

  patternMatch: {
    candleChartAriaLabel: 'Candlestick Chart',
    overlayChartAriaLabel: 'Current pattern overlaid with top 5 historical matches',
    currentLabel: 'Current',
    up: 'Up',
    down: 'Down',
    viewMatch: 'View Match #{rank}',
    matchScore: 'Match Score',
    matchZone: 'Match Zone',
    forwardZone: 'Forward Zone',
    return: 'Return',
    maxDrawdown: 'Max Drawdown',
    maxRunup: 'Max Runup',
    selectedCaseTitle: 'Selected Case #{rank}',
    selectedCaseDesc: 'Match zone {startDate} ~ {endDate}, forward observation to {observationEndDate}',
    forwardReturn: 'Forward Return',
    caseDetailNote: 'This chart shows a single historical case for reference only, not investment advice.',
    dataNotesTitle: 'Data Notes',
    matchScoreDesc: ': Calculated from normalized Euclidean distance. Higher = more similar.',
    matchZoneDesc: ': The historical K-line segment identified as a similar pattern.',
    forwardZoneDesc: ': The real price action observed after the match zone ends.',
    returnDesc: ': Price change from the last candle close in the match zone.',
    maxDrawdownRunup: 'Max Drawdown / Runup',
    maxDrawdownRunupDesc: ': Maximum loss and gain relative to match-end close in the forward zone.',
    csvLoadError: 'Failed to load BTC/USDT 1D CSV data',
    loading: 'Loading BTC/USDT 1D data...',
    noCandleData: 'No candle data available',
    pageTitle: 'BTC Pattern Match',
    pageDesc: 'Match recent BTC daily candles against history to see what happened next.',
    patternLengthLabel: 'Pattern Length',
    forwardWindowLabel: 'Forward Window',
    exclusionWindowLabel: 'Exclude Recent',
    matchCount: 'Matches',
    top5UpRatio: 'Top5 Up Ratio',
    avgForwardReturn: 'Avg Forward Return',
    medianReturn: 'Median Return',
    avgMaxDrawdown: 'Avg Max Drawdown',
    currentVsTop5: 'Current vs Top 5 Historical Matches',
    currentVsTop5Desc: 'Left: current candles. Right: normalized bar comparison.',
    latestClose: 'Latest Close',
    dayUnit: 'd',
    currentCandleTrend: 'Current Candle Trend',
    barNormalizedSimilarity: 'Normalized Similarity Bars',
    top5DetailTitle: 'Top 5 Match Details',
    top5DetailDesc: 'Red background = real forward price action. Blue dashed line = match end point.',
    dumpDetectiveLink: 'Dump Detective 3.0',
    supportResistanceLink: 'Support / Resistance',
    toolboxDescription: 'Pattern matching, risk detection, and S/R analysis for your trading decisions.',
  },

  detective: {
    errorChainNotOpen: 'This chain is not yet supported. Currently only BSC is available.',
    errorInvalidAddress: 'Please enter a valid BSC contract address (0x-prefixed 42-char hex)',
    title: 'Dump Detective 3.0',
    description: 'Enter a token contract address to generate an on-chain risk detection report.',
    tagContract: 'Contract Safety',
    tagLiquidity: 'Liquidity',
    tagHolders: 'Holder Structure',
    selectChain: 'Select Chain',
    available: 'Available',
    notAvailable: 'Not Available',
    tokenContractAddress: 'Token Contract Address',
    startDetect: 'Start Detection',
    exampleBabyDoge: 'Example: BabyDoge',
    footnote: 'This tool is for on-chain risk detection only, not investment advice. Data from public on-chain sources may be delayed.',
    toolboxDescription: 'Risk detection, pattern matching, and S/R analysis for your trading decisions.',
    patternMatch: 'Pattern Match',
    supportResistance: 'Support / Resistance',
  },

  detectiveReport: {
    scoreContract: 'Contract Safety',
    scoreLiquidity: 'Liquidity Health',
    scoreHolders: 'Holder Structure',
    scoreProject: 'Project Behavior',
    scoreSmartMoney: 'Smart Money Signal',
    scoreMarket: 'Market Activity',
    notConnected: 'Not Connected',
    yes: 'Yes',
    no: 'No',
    safetyScoreOutOf100: 'Safety Score / 100',
    overallRating: 'Overall Rating',
    safetyGaugeDesc: 'Higher score = safer contract and liquidity pool.',
    riskRadar: 'Risk Radar',
    dataNotFullyConnected: 'Some data sources are not yet connected.',
    dexscreenerQuote: 'DexScreener Quote',
    connected: 'Connected',
    fetchFailed: 'Fetch Failed',
    mainPoolDex: 'Main Pool DEX',
    noData: 'No Data',
    mainPoolAddress: 'Main Pool Address',
    contractOpenSource: 'Contract Open Source',
    suspectedHoneypot: 'Suspected Honeypot',
    mintable: 'Mintable',
    blacklistMechanism: 'Blacklist Mechanism',
    ownerNotRenounced: 'Owner Not Renounced',
    buySellTax: 'Buy Tax / Sell Tax',
    holderData: 'Holder Data',
    detectionDetails: 'Detection Details',
    backToDetect: 'Back to Detection',
    errorBscOnly: 'Only BSC EVM contract addresses are supported.',
    errorApiFailed: 'Analysis API request failed.',
    generatingReport: 'Generating Risk Report',
    generatingReportDesc: 'Requesting Cloudflare Function for on-chain analysis...',
    cannotGenerateReport: 'Cannot Generate Report',
    reportDataEmpty: 'Report data is empty.',
    price: 'Price',
    change24h: '24h Change',
    liquidity: 'Liquidity',
    volume24h: '24h Volume',
    riskWarnings: 'Risk Warnings',
    ruleSummary: 'Rule Summary',
    summaryDisclaimer: 'This tool is for on-chain risk detection only, not investment advice.',
    toolboxDescription: 'Continue using other tools after this risk analysis.',
    patternMatch: 'Pattern Match',
    supportResistance: 'Support / Resistance',
  },

  levels: {
    interval15m: '15 Min',
    interval1h: '1 Hour',
    interval4h: '4 Hours',
    interval1d: '1 Day',
    toolPatternMatch: 'Pattern Match',
    toolDumpDetective: 'Dump Detective 3.0',
    seconds: 's',
    minutes: 'min',
    priceCloserTip: 'Closer to current price = more relevant',
    price: 'Price',
    distance: 'Distance',
    strength: 'Strength',
    touches: 'Touches',
    strength_strong: 'Strong',
    strength_medium: 'Medium',
    strength_weak: 'Weak',
    touchesCount: '{count} times',
    rateLimitRemaining: '{remaining} / {limit} remaining',
    rateLimitDisabled: 'Query limit reached, please try again later',
    currentPrice: 'Current Price',
    updated: 'Updated',
    queryInterval: 'Interval',
    binanceKlineTip: 'Data source: Binance K-line',
    queryQuota: 'Query Quota',
    quotaCooldownTip: 'Cooldown required after each query',
    unsupportedSymbol: 'Symbol not supported',
    queryFailed: 'Query failed, please try again later',
    pageTitle: 'Support / Resistance',
    pageDesc: 'Query key support and resistance levels for major cryptocurrencies.',
    multiInterval: 'Multi-timeframe',
    symbol: 'Symbol',
    querying: 'Querying...',
    queryBtn: 'Query',
    popular: 'Popular',
    selectInterval: 'Select Interval',
    querySettings: 'Query Settings',
    querySettingsDesc: 'Select symbol and interval to get key price levels',
    pleaseWait: 'Please wait {time}',
    resistance: 'Resistance',
    noResistances: 'No resistance data',
    support: 'Support',
    noSupports: 'No support data',
    nearby: 'Nearby Levels',
    noNearby: 'No nearby level data',
    dataDisclaimer: 'Data Disclaimer',
    dataDisclaimerDesc: 'Data from Binance K-line history. For reference only, not investment advice.',
    notInvestAdvice: 'Not investment advice',
    toolboxDesc: 'S/R levels, pattern matching, and risk detection for your trading decisions.',
  },

  social: {
    title: 'Community Updates',
    desc: 'Latest insights and market analysis from X',
    viewSource: 'View Original',
    viewAll: 'View All',
    navLabel: 'Updates',
    empty: 'No updates yet',
    loading: 'Loading...',
    sectionTitle: 'Community Updates',
    sectionDesc: 'Latest insights from X',
    postedAt: '{time}',
    imageAlt: 'Post image',
  },

  instList: {
    title: 'Institution Holdings 13F',
    desc: 'Track the latest quarterly holdings of top global institutions. Data from SEC EDGAR, updated quarterly.',
    loading: 'Loading institution holdings...',
    filingDate: 'Filed',
    totalValue: 'Total Value',
    holdingsCount: 'Holdings',
    topHoldings: 'Top 3 Holdings',
    viewDetail: 'View Full Holdings',
    source: 'Source: SEC EDGAR public filings. For reference only, not investment advice.',
  },

  fundPage: {
    title: 'Stock Fundamentals',
    desc: 'Core quarterly financial metrics for leading US stocks, powered by SEC EDGAR XBRL data.',
    loading: 'Loading fundamentals...',
    error: 'Failed to load data, please try again later',
    company: 'Company',
    ticker: 'Ticker',
    revenue: 'Revenue',
    netIncome: 'Net Income',
    growth: 'Rev Growth',
    eps: 'EPS',
    grossProfit: 'Gross Profit',
    operatingIncome: 'Operating Income',
    nextEarnings: 'Next Earnings',
    rating: 'Rating',
    ratingBuy: 'Buy',
    ratingHold: 'Hold',
    ratingWatch: 'Watch',
    viewDetail: 'Detail',
    source: 'Source: SEC EDGAR Company Facts / Yahoo Finance quote. For reference only, not investment advice.',
  },

  lang: {
    zh: 'C',
    en: 'N',
  },

  cs: {
    label: 'Support',
    title: 'Contact Us',
    copyTip: 'Click to copy WeChat ID',
    copied: 'Copied',
    feedback: 'Feedback',
    comingSoon: 'Coming Soon',
  },
};

export default en;
